var moment = require('moment');
var vsprintf = require('sprintf-js').vsprintf;

var React = require('react');
var cx = require('classnames');
var Link = require('react-router').Link;
var Table = require('react-bootstrap').Table;


var Constants = require('../../constants/Constants');
var Currency = require('../../util/Currency');
var InvoiceActions = require('../../actions/InvoiceActions');
var Invocation = require('../../api/Invocation');
var InvoiceStore = require('../../stores/Invoice/InvoiceStore');
var Loading = require('../Loading');
var Paginator = require('../Paginator/Paginator');

function getState(pageNumber, refreshing) {
    const state = {
        pageNumber: pageNumber,
        invoices: InvoiceStore.get().invoices,
        firstResult: (Constants.RPP * (pageNumber - 1)) + 1,
        lastResult: Constants.RPP * pageNumber,
        total: InvoiceStore.get().total,
        pageCount: Math.ceil(InvoiceStore.get().total / Constants.RPP),
        loading: InvoiceStore.loading()
    };
    if (refreshing !== undefined) {
        state.refreshing = refreshing;
    } else {
        if (!state.loading) {
            state.refreshing = false;
        }
    }
    return state;
}

var InvoiceTable = React.createClass({
    statics: {
        handleInvoiceClick: function (e, invoice) {
            var link = $(e.target);
            if (!link.is('a')) {
                link = link.closest('a');
            }

            link.attr('href', Invocation.invoice.buildPdfUrl(invoice));
        }
    },
    componentDidMount: function() {
        InvoiceStore.addChangeListener(this.update);
    },
    componentWillMount: function () {
        InvoiceActions.getInvoices(this.state.pageNumber);
    },
    componentWillUnmount: function () {
        InvoiceStore.removeChangeListener(this.update);
    },
    getInitialState: function () {
        return Object.assign({}, getState(1, false), {sortBy: 'dueDate'});
    },

    render: function () {
        return <section className="powerwidget">
            <header><h2>Invoices</h2></header>
            <div className="inner-spacer">
                {this.state.pageCount > 1 &&
                  <div className="row">
                      <div className="col-md-6">
                          {this.props.children}
                      </div>
                      <div className="col-md-6 text-right">
                          {this.state.refreshing && <Loading message="" />}
                          Showing {this.state.firstResult} - {this.state.lastResult} of {this.state.total} invoices&nbsp;
                          <Paginator currentPage={this.state.pageNumber} pageCount={this.state.pageCount} onPageSelected={this.setPage} disabled={this.state.loading} />
                      </div>
                  </div>}
                {this.renderTable()}
            </div>
        </section>;
    },
    renderInvoiceRow: function (invoice, hasCreditColumn) {
        const unpaid = (invoice.paid || 0) < invoice.total;
        const owing = invoice.total - invoice.paid;
        const rowClasses = {
            danger: unpaid && moment(invoice.due_date).isBefore(),
            outstanding: unpaid && !moment(invoice.due_date).isBefore()
        };
        const creditTotal = invoice.credits.reduce((acc, credit) => acc + credit.amount, 0);
        const adjustedPaymentTotal = invoice.paid - creditTotal;

        let number = <span>{invoice.number}</span>;
        if (invoice.pdfAvailable) {
            const click = e => InvoiceTable.handleInvoiceClick.call(this, e, invoice);

            number = <a href="#" target="_new" onClick={click} onContextMenu={click}><i className="fa fa-file-pdf-o"></i> {invoice.number}</a>
        }

        return <tr key={invoice.id} className={cx(rowClasses)}>
            <td>{number}</td>
            <td>{moment(invoice.due_date).format('YYYY-MM-DD')}</td>
            <td>{Currency.format(invoice.total)}</td>
            <td>{Currency.format(adjustedPaymentTotal)}</td>
            {hasCreditColumn && <td>{creditTotal > 0 ? Currency.format(creditTotal) : ''}</td>}
            <td>{owing > 0 && Currency.format(owing)}</td>
            <td>{unpaid && <Link to="payment">Pay Invoice</Link>}</td>
        </tr>
    },
    renderTable: function () {
        if (this.state.loading && !this.state.refreshing) {
            return <Loading />;
        }

        const hasCreditColumn = this.state.invoices.filter(invoice => invoice.credits.length > 0).length > 0;

        return <div className="table-responsive">
            <Table className="table-striped table-hover">
                <col style={{width: '16%'}} />
                <col style={{width: '16%'}} />
                <col style={{width: '16%'}} />
                {hasCreditColumn && <col style={{width: '16%'}}/>}
                <col style={{width: '16%'}} />
                <col style={{width: '16%'}} />
                <col style={{width: '16%'}} />
                <thead><tr>
                    <th>Invoice Number</th>
                    <th className={cx({sortable: true, desc: this.state.sortBy === 'dueDate'})} onClick={() => this.props.disabled || this.setSortColumn('dueDate')}>Date Due</th>
                    <th className={cx({sortable: true, desc: this.state.sortBy === 'total'})} onClick={() => this.props.disabled || this.setSortColumn('total')}>Total</th>
                    <th>Paid</th>
                    {hasCreditColumn && <th>Credited</th>}
                    <th className={cx({sortable: true, desc: this.state.sortBy === 'owing'})} onClick={() => this.props.disabled || this.setSortColumn('owing')}>Amount Owing</th>
                    <th></th>
                </tr></thead>
                <tbody>
                    {this.state.invoices.map(invoice => this.renderInvoiceRow(invoice, hasCreditColumn))}
                </tbody>
            </Table>
        </div>;
    },

    setSortColumn: function (sortOrder) {
        this.setState({pageNumber: 1, sortBy: sortOrder, refreshing: true}, () => {
            InvoiceActions.getInvoices(this.state.pageNumber, {sortBy: this.state.sortBy})
        });
    },

    setPage: function (pageNumber) {
        this.setState({pageNumber: pageNumber, refreshing: true}, () => {
            InvoiceActions.getInvoices(this.state.pageNumber, {sortBy: this.state.sortBy})
        });
    },

    update: function () {
        this.setState(getState(this.state.pageNumber));
    }
});
module.exports = InvoiceTable;



// WEBPACK FOOTER //
// ./app/components/Invoice/Table.js